import { setupConfig } from '@ionic/react';
import React from 'react';
import ReactDOM from 'react-dom';

import { AppContextProvider } from './state';
import createBrowserHistory from './config/history';

import App from './App';
import * as serviceWorker from './serviceWorker';

const history = createBrowserHistory;

// Global Ionic configuration
setupConfig({
	mode: 'ios'
})

ReactDOM.render(
	<AppContextProvider>
		<App history={history} />
	</AppContextProvider>
	, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
